/** Cabeçalho da coluna na agenda por sala: a cor e o nome no lugar do dia. */
export function CabecalhoDaSala({ nome, cor }: { nome: string; cor: string | null }) {
  return (
    <span className="flex min-w-0 items-center gap-2 px-2">
      <span className={cor ? "h-2.5 w-2.5 shrink-0 rounded-full" : "h-2.5 w-2.5 shrink-0 rounded-full border border-dashed border-zinc-400"} style={cor ? { backgroundColor: cor } : undefined} />
      <span className="truncate text-sm font-semibold text-zinc-800 dark:text-foreground">{nome}</span>
    </span>
  );
}
